/* Lauven — taille obligatoire sur la fiche (05/10, demande user).
   Le theme preselectionne la 1re taille disponible : un clic sur « Ajouter au panier »
   ajoutait donc du S sans que la cliente ait choisi. Tant qu'elle n'a pas touche une
   taille, la taille preselectionnee n'apparait pas choisie, et « Ajouter au panier »
   (bouton principal ou barre collante) fait defiler jusqu'aux tailles au lieu d'ajouter.
   Seul l'axe TAILLE est concerne (pas la couleur). Une URL avec ?variant= (Google
   Shopping, lien partage) compte comme une taille deja choisie. */
(() => {
  if (window.__lvTaille) return;
  window.__lvTaille = true;
  const VALEUR_TAILLE = /^(xxs|xs|s|m|l|xl|xxl|2xl|3xl|4xl|5xl|\d{1,2})$/i;
  let choisie = new URLSearchParams(location.search).has('variant');

  const picker = () => document.querySelector('[id$="__main"] variant-picker');

  function fieldsetTaille() {
    const p = picker();
    if (!p) return null;
    for (const fs of p.querySelectorAll('fieldset.variant-option')) {
      const vals = [...fs.querySelectorAll('input[type="radio"]')].map((i) => i.value.trim());
      if (vals.length > 1 && vals.filter((v) => VALEUR_TAILLE.test(v)).length >= Math.ceil(vals.length / 2)) return fs;
    }
    return null;
  }

  function placer() {
    const fs = fieldsetTaille();
    const msg = document.querySelector('.lv-taille-msg');
    const ech = document.querySelector('.lv-taille-echange');
    if (!fs) {
      document.body.classList.remove('lv-taille-a-choisir');
      return;
    }
    fs.classList.add('lv-fs-taille');
    if (ech && fs.nextElementSibling !== msg && fs.nextElementSibling !== ech) {
      fs.after(ech);
      if (msg) fs.after(msg);
    }
    if (ech) ech.hidden = false;
    document.body.classList.toggle('lv-taille-a-choisir', !choisie);
  }

  function marquerChoisie() {
    choisie = true;
    document.body.classList.remove('lv-taille-a-choisir');
    const msg = document.querySelector('.lv-taille-msg');
    if (msg) msg.hidden = true;
  }

  // ecoute sur window en phase de capture : passe AVANT les gestionnaires du theme
  // (sinon la barre collante affichait la coche « ajoute » sans rien ajouter)
  window.addEventListener(
    'click',
    (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('.lv-fs-taille label, .lv-fs-taille input')) {
        marquerChoisie();
        return;
      }
      if (!document.body.classList.contains('lv-taille-a-choisir')) return;
      const bouton = t.closest('.add-to-cart-button, button[name="add"]');
      if (!bouton) return;
      // seulement le bouton de la fiche et celui de la barre collante
      if (!bouton.closest('[id$="__main"], sticky-add-to-cart')) return;
      if (bouton.closest('dialog, quick-add-component')) return;
      const fs = fieldsetTaille();
      if (!fs) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      setTimeout(() => document.querySelectorAll('.add-to-cart-button[data-added]').forEach((b) => b.removeAttribute('data-added')), 0);
      const msg = document.querySelector('.lv-taille-msg');
      if (msg) msg.hidden = false;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fs.classList.remove('lv-taille-alerte');
      void fs.offsetWidth;
      fs.classList.add('lv-taille-alerte');
    },
    true
  );

  const demarrer = () => {
    placer();
    const p = picker();
    if (p) {
      let attente = 0;
      new MutationObserver(() => {
        cancelAnimationFrame(attente);
        attente = requestAnimationFrame(placer);
      }).observe(p, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
